define('controllers/myaccount/balance/flow-detail.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('FlowDetailCtrl', ['$scope','$stateParams', function ($scope,$stateParams) {
        var Model = $scope.Model = {}
        $scope.signParty = 2 // 跳转回耀星列表页
        $scope.orderInfo = {}
        $scope.orderInfo.orderId = $stateParams.orderId
        Model.constant = {
            orderStatus: mainCons.balanceConstant.orderStatus,
            purchaseType:mainCons.balanceConstant.purchaseType,
            contractType:mainCons.balanceConstant.contractType,
            isForCpType:mainCons.balanceConstant.isForCpType
        };
    }])
})
;
